const Signatures = () => {
  return (
    <div className="min-h-full w-full bg-orange-500"> Signatures page</div>
  );
};
export default Signatures;
